import { render, staticRenderFns } from "./GiftingAddressesTable.vue?vue&type=template&id=69735aab&"
import script from "./GiftingAddressesTable.vue?vue&type=script&lang=js&"
export * from "./GiftingAddressesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports